import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize, map } from 'rxjs/operators';
import { FileI } from '../shared/file.interface';
import { ProductI } from '../shared/producto.interface';


@Injectable({
  providedIn: 'root'
})
export class ProductosService {

  productos: any;
  producto: any;
  carro: any;
  solicitudes: number;
  solicitud = [];
  clientesMora = [];
  private filePath: any;
  private downloadURL: string;
  constructor(private db: AngularFirestore,
              private storage: AngularFireStorage) { }

  cargarProductosDistribuidor(){
   return this.db.collection('prodSuPedido', ref => ref
                 .where('categoria', '==', 'TAYCO'))
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                      actions.map(resp => {
                      const data = resp.payload.doc.data() as any;
                      const id = resp.payload.doc.id;
                      return {id, ...data};
                      }))
                    );
  }
  cargarProductosCliente(){
    return this.db.collection('prodSuPedido')
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                     const data = resp.payload.doc.data() as any;
                     const id = resp.payload.doc.id;
                     return {id, ...data};
                     }))
                    );
  }

  cargarProductosAdmin(){
    return this.db.collection('prodSuPedido')
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                     const data = resp.payload.doc.data() as any;
                     const id = resp.payload.doc.id;
                     return {id, ...data};
                     }))
                    );
  }

  CargarElementos(id: string){
    return new Promise((resolve, reject) => {
      this.db.collection('productos/', ref => ref
             .where('categoria', '==', id)).get().forEach(res => {
        if (res.empty){
          reject('error');
        }else{
          const datapro = [];
          res.forEach(res1 => {
            datapro.push([res1.data(), res1.id]);
          });
          resolve(datapro);
        }
      }).catch();
    });
  }

  crearCompra(compra: any){
    this.solicitud.push(compra);
    this.guardaStorage();
  }

  guardaStorage(){
    localStorage.setItem('data', JSON.stringify(this.solicitud));
  }

  updateStorage(compra: any){
    localStorage.setItem('data', JSON.stringify(compra));
  }

  cargarSolicitudCompra(solicitud: any){
    return this.db.collection('ventas').add(solicitud);
  }

  invoice(){
    return this.db.collection('consecutivo').doc('gjDetP58ItwtyUAdo8Lw').valueChanges();
  }

  crearFactura(factura: any){
    return this.db.collection('facturacion').add(factura);
  }

  actualizarConsecutivo(nuevoNum: number){
    return this.db.collection('consecutivo').doc('gjDetP58ItwtyUAdo8Lw').update({factura: nuevoNum});
  }

  visualizarFacturas(){
    return this.db.collection('facturacion', ref => ref
                  .where('tipoPago', '==', 'credito'))
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                     const data = resp.payload.doc.data() as any;
                     const id = resp.payload.doc.id;
                     return {id, ...data};
                     }))
                    );
  }

  visualizarFacturasContado(){
    return this.db.collection('facturacion', ref => ref
                  .where('tipoPago', '==', 'contado'))
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                     const data = resp.payload.doc.data() as any;
                     const id = resp.payload.doc.id;
                     return {id, ...data};
                     }))
                    );
  }

  pagoCuotaCredito(idFact: string, fecha: number, cuota: number){
    return this.db.collection('facturacion').doc(idFact).update({
      ultimoPago: fecha,
      abonos: cuota
    });
  }

  historialAbonos(abono: any){
    return this.db.collection('abonos').add(abono);
  }

  verHistorialAbonos(factura: number){
    return this.db.collection('abonos', ref => ref
                  .where('factura', '==', factura))
                  .valueChanges();
  }

  actualizaConsecutivo(consec: number){
    return this.db.collection('consecutivo').doc('gjDetP58ItwtyUAdo8Lw').update({factura: consec});
  }

  cargarPedidosPorUsuario(idUser: string){
    return this.db.collection('ventas', ref => ref
                  .where('cliente', '==', idUser))
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                     const data = resp.payload.doc.data() as any;
                     const id = resp.payload.doc.id;
                     return {id, ...data};
                     }))
                    );
  }

  cargarPedidosPendientes(){
    return this.db.collection('ventas', ref => ref
                  .where('estado', '==', 'Pendiente'))
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                     const data = resp.payload.doc.data() as any;
                     const id = resp.payload.doc.id;
                     return {id, ...data};
                     }))
                    );
  }
  cargarPedidosAceptados(){
    return this.db.collection('ventas', ref => ref
                  .where('estado', '==', 'En envio'))
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                     const data = resp.payload.doc.data() as any;
                     const id = resp.payload.doc.id;
                     return {id, ...data};
                     }))
                    );
  }
  cargarPedidosCancelados(){
    return this.db.collection('ventas', ref => ref
                  .where('estado', '==', 'Cancelado'))
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                     const data = resp.payload.doc.data() as any;
                     const id = resp.payload.doc.id;
                     return {id, ...data};
                     }))
                    );
  }
  cargarTodosPedidos(){
    return this.db.collection('ventas')
                  .snapshotChanges()
                  .pipe(
                    map(actions =>
                     actions.map(resp => {
                     const data = resp.payload.doc.data() as any;
                     const id = resp.payload.doc.id;
                     return {id, ...data};
                     }))
                    );
  }

  aceptarPedido(idPedido: string){
    return this.db.collection('ventas').doc(idPedido).update({estado: 'En envio'});
  }

  cancelarPedido(idPedido: string){
    return this.db.collection('ventas').doc(idPedido).update({estado: 'Cancelado'});
    // return this.db.collection('ventas').doc(idPedido).delete();
  }

  filterProd(producto: ProductI, image: FileI){
    this.uploadImage(producto, image);
  }

  private uploadImage(producto: ProductI, image: FileI){
    this.filePath = `productos/${image.name}`;
    const fileRef = this.storage.ref(this.filePath);
    const task = this.storage.upload(this.filePath, image);
    task.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe( urlImage => {
          this.downloadURL = urlImage;
          this.agregarUsuarios(producto);
        });
      })
    ).subscribe();
 }

 private agregarUsuarios(producto: ProductI){
    const prodObj = {
      amarillo: producto.amarillo,
      azul: producto.azul,
      gris: producto.gris,
      categoria: producto.categoria,
      citronela: producto.citronela,
      descripcion: producto.descripcion,
      fechaCreacion: producto.fechaCreacion,
      floral: producto.floral,
      gr1000: producto.gr1000,
      gr1500: producto.gr1500,
      imageProd: this.downloadURL,
      kg1: producto.kg1,
      kg4: producto.kg4,
      precio: producto.precio,
      kg21: producto.kg21,
      kg22: producto.kg22,
      kg44: producto.kg44,
      kiwi: producto.kiwi,
      lavanda: producto.lavanda,
      limon: producto.limon,
      frutosRojos: producto.frutosRojos,
      lt1: producto.lt1,
      lt5: producto.lt5,
      lt20: producto.lt20,
      ltr38: producto.ltr38,
      ltrPist: producto.ltrPist,
      ltrPistRep: producto.ltrPistRep,
      ltvalvula: producto.ltvalvula,
      negro: producto.negro,
      nombre: producto.nombre,
      rojo: producto.rojo,
      sinAroma: producto.sinAroma,
      tL: producto.tL,
      tM: producto.tM,
      tS: producto.tS,
      verde: producto.verde,
      vinagre: producto.vinagre,
      fileRef: this.filePath,
    };

    if (producto.id) {
      return this.db.collection('prodSuPedido').doc(producto.id).update(prodObj);
    } else {
      return this.db.collection('prodSuPedido').add(prodObj);
    }
  }

  borrarProducto(idProd: string){
    return this.db.collection('prodSuPedido').doc(idProd).delete();
  }

  getProductById(id: string){
    return this.db.collection('prodSuPedido').doc(id).valueChanges();
  }

  updateProductById(producto: ProductI, newImage?: FileI){
    if (newImage) {
      this.uploadImage(producto, newImage);
    } else {
      return this.db.collection('prodSuPedido').doc(producto.id).update(producto);
    }
  }

  asignarDescuentoDistribuidor(idDist: string, descto: number){
    return this.db.collection('usuarios').doc(idDist).update({descuento: descto});
  }

  asignarDescuentoProducto(idProd: string, descto: number){
    return this.db.collection('prodSuPedido').doc(idProd).update({descuento: descto})
  }
}
